import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';

@Injectable()
export class RpsGuiasUrgenciaEmergenciaService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getData(regans: string, competencia: string, competencia_final: string, situacao_rps?: number[]) {
    return this.simuladorGoApi
      .fetchRpsGuiasUrgenciaEmergencia({ regans, competencia, competencia_final, situacao_rps })
      .pipe(map(data => data.items));
  }

  getUltimoProcessamento(regans: string) {
    return this.simuladorGoApi.fetchRpsGuiasUrgenciaEmergenciaUltimoProcessamento({ regans });
  }
}
